<template>
  <RequireAdContract>
    <WithCampaignInternalNav>
      <Content
        class="campaign-view"
        :title="$t('ADVERTISEMENT.CAMPAIGN_DETAILS.TITLE')"
      >
        <div class="campaign-view__info">
          <span>{{ $t('ADVERTISEMENT.CAMPAIGN_VIEW.CAMPAIGN_NAME') }}:</span>
          <span>
            {{ campaignInfo.name }}
          </span>
        </div>

        <div class="campaign-view__info">
          <span>{{ $t('ADVERTISEMENT.CAMPAIGN_VIEW.STATUS') }}:</span>
          <span :class="campaignStatusClass">
            {{ $t(translateCampaignStatus(campaignInfo.status)) }}
          </span>
        </div>

        <hr class="divider" />

        <Transition name="fade-transform" mode="out-in">
          <RouterView @update="getCampaignInfo" />
        </Transition>
      </Content>
    </WithCampaignInternalNav>
  </RequireAdContract>
</template>

<script>
import RequireAdContract from '../../common/RequireAdContract';
import WithCampaignInternalNav from './WithCampaignInternalNav';
import Content from '@@/common/layout/Content';
import translateCampaignStatus from '../../common/utility/translators/translateCampaignStatus';
import { BasicAdsCampaigns } from '@/api/api';
import campaignId from '@/mixins/advertisement/campaignId';

export default {
  name: 'CampaignView',

  components: {
    RequireAdContract,
    WithCampaignInternalNav,
    Content,
  },

  mixins: [campaignId],

  data() {
    return {
      isLoading: true,

      campaignInfo: {
        name: '',
        status: '',
        isPaused: false,
      },
    };
  },

  computed: {
    campaignStatusClass() {
      const { status } = this.campaignInfo;
      return {
        'text-success': status === 'active',
        'text-alert': status === 'paused',
        'text-warning': status !== 'active' && status !== 'paused',
      };
    },
  },

  mounted() {
    this.getCampaignInfo();
  },

  methods: {
    translateCampaignStatus,
    getCampaignInfo() {
      this.isLoading = true;
      return BasicAdsCampaigns.getCampaignInfo(this.campaignId)
        .then(({ name, status, isPaused }) => {
          this.campaignInfo = {
            name,
            status: status.toLowerCase(),
            isPaused,
          };
        })
        .catch(({ message }) => {
          if (message) {
            this.$message.error(message);
          }
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
};
</script>

<style lang="scss">
.campaign-view {
  &__info {
    margin-bottom: $global-margin / 2;
  }
}
</style>
